import { AfterViewInit, Directive, Host, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { DataTableNewComponent } from '../data-table-new.component';
import { DataTableState } from '../state/state.model';
import { StateService } from '../state/state.service';

export interface DataTablePageState {
  index: number;
  size: number;
}

@Directive({ selector: '[vfsDatatableInfiniteScroll]', exportAs: 'vfsDatatableInfiniteScroll' })
export class DatatableInfiniteScrollDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() maxNumOfNotifications: number;

  stateId: string;
  stateChangeSubject$: Subject<DataTableState>;

  scrollSubscription: Subscription;

  constructor(
    @Host() private parent: DataTableNewComponent<any>,
    @Inject('StateService') private stateService: StateService
  ) {}

  ngOnInit() {
    this.stateId = this.parent.stateId;
    this.stateChangeSubject$ = this.parent.stateChangeSubject$;
    this.parent.withInfiniteScroll = true;

    if (!this.maxNumOfNotifications) {
      throw Error('Invalid maxNumOfNotifications parameter');
    }
  }

  ngAfterViewInit() {
    const currentState: DataTableState = this.stateService.get(this.stateId);

    if (!this.parent.scrollSubject$) {
      throw Error('Invalid scrollSubject parameter is null');
    }

    this.scrollSubscription = this.parent.scrollSubject$.subscribe(_ => {
      if ((currentState.page.index + 2) * currentState.page.size <= this.maxNumOfNotifications) {
        currentState.page.index = currentState.page.index + 1;
        this.stateService.update(currentState);
        this.stateChangeSubject$.next(currentState);
      }
    });
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }

    const currentState: DataTableState = this.stateService.get(this.stateId);
    currentState.page.index = 0;
    this.stateService.update(currentState);
  }
}
